import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoordinatesSelectorComponent } from './coordinates-selector/coordinates-selector.component';
import { TranslateModule } from '@ngx-translate/core';
import { DrawingControlModule } from '@bcl/drawing-control';

@NgModule({
  imports: [CommonModule, DrawingControlModule, TranslateModule],
  declarations: [CoordinatesSelectorComponent],
  exports: [CoordinatesSelectorComponent],
})
export class ComponentsModule {}
